import React from "react";
import FlipBook from "./FlipBook";
import './Gallery.css'
import useIsMobile from "../../hooks/useIsMobile";
import { fetchGallery } from "../../api/gallery";
import { useApi } from "../../hooks/useApi";
import { fetchMedia } from "../../api/media";
import { LoadingBox } from "../../components/LoadingBox";

const fetchInBatches = async (items, fetchFn, batchSize = 4) => {
  const results = [];
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    const batchResults = await Promise.all(batch.map(fetchFn));
    results.push(...batchResults);
  }
  return results;
};

const Gallery = () => {
  const isMobile = useIsMobile(550);

  const { output: mediaLinks, loading, error } = useApi(() =>
    fetchGallery()
      .then(imagePosts => {
        const allImageIds = imagePosts.flatMap(post => {
          const img = post.acf.image;
          if (!img || img === false || img === 0) return [];
          return Array.isArray(img) ? img : [img];
        }).filter(id => !!id && typeof id === 'number' && id > 0);

        return fetchInBatches(allImageIds, id => fetchMedia(id), 4);
      })
      .then(results => results
        .filter(item => item?.source_url)
        .map(item => item.source_url)
        .reverse()
      )
  );

  if (!mediaLinks || !Array.isArray(mediaLinks) || mediaLinks.length === 0) {
    return (
      <div className="loading-wrapper">
        <LoadingBox />
      </div>
    );
  }

  return (
    <div className="gallery-container">
      <FlipBook isMobile={isMobile} pMediaLinks={mediaLinks} />
    </div>
  );
};

export default Gallery;